export const IMAGES = [
  { src: "https://i.ibb.co/SBgJfvn/Image-Editor-1.jpg", thumbnail: "" },
  { src: "https://i.ibb.co/5n0zb9j/Image-Editor-2.jpg", thumbnail: "" },
  { src: "https://i.ibb.co/wKth52C/Image-Editor-3.jpg", thumbnail: "" },
  { src: "https://i.ibb.co/MhQ0QwG/Image-Editor-4.jpg", thumbnail: "" },
  { src: "https://i.ibb.co/8Pr5mqc/Image-Editor-5.jpg", thumbnail: "" },
  { src: "https://i.ibb.co/zhg6YSW/Image-Editor-6.jpg", thumbnail: "" },
  { src: "https://i.ibb.co/m8S8Kmx/Image-Editor-7.jpg", thumbnail: "" },
];